/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Text, TEXT_VARIANTS, Row } from "..";
import { COLORS } from "../../shared/theme";

export const Button: React.FC<
  React.ComponentPropsWithoutRef<"button"> & {
    variant?: "solid" | "ghost" | "caps" | "caps-active" | "caps-disabled";
    size?: "big" | "default";
    trailingElement?: () => JSX.Element;
    leadingElement?: () => JSX.Element;
    label?: string;
    align?: "start" | "center" | "end";
    expand?: boolean;
    textVariant?: TEXT_VARIANTS;
    textColor?: typeof COLORS[keyof typeof COLORS];
  }
> = ({
  trailingElement,
  leadingElement,
  label,
  textVariant = TEXT_VARIANTS.T20BOLD,
  textColor,
  align = "center",
  variant = "ghost",
  size = "default",
  expand = false,
  ...props
}) => (
  <Row
    mainAxisAlignment={align}
    crossAxisAlignment="center"
    as="button"
    gap={5}
    css={css`
      transition: all 120ms ease;
      cursor: pointer;
      height: ${size === "default" ? 35 : 45}px;
      width: ${expand ? "100%" : "unset"};
      padding: 0 10px;
      padding-left: ${leadingElement !== undefined || label === undefined
        ? 5
        : 10}px;
      padding-right: ${trailingElement !== undefined || label === undefined
        ? 5
        : 10}px;
      border: none;
      border-radius: 10px;
      background-color: ${variant === "ghost"
        ? "transparent"
        : variant === "solid"
        ? COLORS.LIGHT
        : variant === "caps"
        ? COLORS.LIGHT
        : variant === "caps-active"
        ? COLORS.LIME
        : COLORS.SILVER};

      &:hover {
        background-color: ${COLORS.LIGHT};
        background-color: ${variant === "ghost" || variant === "solid"
          ? COLORS.LIGHT
          : variant === "caps"
          ? COLORS.LIGHT
          : variant === "caps-active"
          ? COLORS.LIME
          : COLORS.SILVER};
      }
    `}
    {...(props as any)}
  >
    {leadingElement !== undefined && leadingElement()}
    {label !== undefined && (
      <Text
        variant={textVariant}
        css={css`
          color: ${textColor !== undefined
            ? textColor
            : variant === "solid" || variant === "ghost"
            ? COLORS.SILVER
            : variant === "caps-active" || variant === "caps"
            ? COLORS.BLACK
            : COLORS.WHITE};
        `}
      >
        {label}
      </Text>
    )}
    {trailingElement !== undefined && trailingElement()}
  </Row>
);
